<template>
  <div class="setting_balloon setting_balloon_category_add">
    <div class="setting_balloon_content">
      <div class="setting_balloon_content_main">
        <div class="setting_balloon_rows">
          <div class="setting_balloon_rows_label">
            <p class="setting_balloon_rows_label_name">
              {{ screenLabelsProperties.CATEGORY_NAME_INPUT_TITLE }}
            </p>
            <p class="setting_label">
              {{ screenLabelsProperties.REQUIRE_LABEL }}
            </p>
          </div>
          <div class="setting_balloon_rows_form">
            <input
              class="setting_form_text"
              type="text"
              v-model="category.categoryName"
              :placeholder="screenLabelsProperties.CATEGORY_PLACEHOLDER"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="setting_balloon_footer">
      <button
        class="setting_btn_outline setting_btn_small"
        @click="$emit('close')"
      >
        {{ screenLabelsProperties.CLOSE_MODAL }}
      </button>
      <button
        class="setting_btn_primary setting_btn_small"
        :class="category.categoryName ? '' : 'setting_btn_disabled'"
        @click="$emit('submit')"
      >
        {{ screenLabelsProperties.SAVE_CATEGORY_BUTTON }}
      </button>
    </div>
  </div>
</template>

<script>
import screenLabelsProperties from "../../../../properties/entry_screen/screen_tab/screen-labels.json";

export default {
  name: "ModalCategory",
  props: ["category"],
  data: function () {
    return {
      screenLabelsProperties: screenLabelsProperties,
    };
  },
};
</script>

<style scoped>
</style>
